<div class="flex items-center">
  <div class="full-width">
    <div class="center">
      <div *ngIf="image || themedImage" class="header">
        <h1 mat-dialog-title class="app-dialog-title center pt2">
          <img *ngIf="image && !themedImage" src="assets/images/{{ image }}" />
          <lib-themed-image *ngIf="themedImage" [name]="themedImage"></lib-themed-image>
        </h1>
      </div>

      <div *ngIf="mainText" class="bold font-medium" [class.mb2]="subText">
        <div [innerHTML]="mainText"></div>
      </div>

      <div *ngIf="subText">
        <div [innerHTML]="subText"></div>
      </div>
    </div>
  </div>
</div>
